import { array, func, number, object, string } from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import ItemsCarousel from 'react-items-carousel';

import JobMatchCard from './JobMatchCard';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import { hasQualityReportRating } from '../../lib/helpers/hasQualityReportRating';
import { IsJobPriced } from './JobHelpers';

import './jobTitleMatch.scss';

export default class JobTitleMatches extends Component {
  static propTypes = {
    // TODO: do we need this whole object?
    addJob: object,
    // TODO: do we need this whole object?
    app: object,
    className: string,
    formSections: object,
    getAllReports: func,
    getJobCerts: func,
    getJobSkills: func,
    handleJobClick: func,
    items: array,
    // TODO: do we need this whole object?
    jobDetails: object,
    jobRowNum: number,
    rangeChartWidth: number,
    saveJob: func,
    selectJob: func,
    selectedJobTitle: number,
    // TODO: do we need this whole object?
    selectedPayscaleJob: object,
    setInitialJobDetails: func,
    feature: string,
    setJobMatchSaving: func,
    setJobMatchError: func
  };

  constructor(props) {
    super(props);

    this.state = {
      activeItemIndex: 1,
      cardClassName: ''
    };

    this.changeActiveItemIndex = this.changeActiveItemIndex.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { searchLoading } = this.props.addJob;

    return searchLoading !== nextProps.addJob.searchLoading || nextProps.addJob.searchLoaded === true;
  }

  componentDidUpdate() {
    const { searchLoading } = this.props.addJob;

    if (searchLoading) this.setState({ activeItemIndex: 1 });
  }

  changeActiveItemIndex(activeItemIndex) {
    this.setState({ activeItemIndex: activeItemIndex });
  }

  async handleSelectJobClick(jobId, jobTitle, tasks, titleVariations, row, titleSelected) {
    const newMatchActions = [];
    const {
      addJob,
      getAllReports,
      getJobCerts,
      getJobSkills,
      handleJobClick,
      selectJob,
      setInitialJobDetails,
      setJobMatchSaving
    } = this.props;

    if (handleJobClick) {
      handleJobClick(jobId, jobTitle, tasks, titleVariations, titleSelected, row);
    } else {
      const now = Date.now();
      setJobMatchSaving(true);

      const jobDetails = {
        ...addJob.jobDetails,
        PayscaleJobTitle: jobTitle,
        Tasks: tasks,
        TitleVariations: titleVariations,
        workLocation: addJob.workLocationExact,
        workLocationExact: addJob.workLocationExact
      };

      newMatchActions.push(selectJob(jobId, jobTitle, addJob.workLocationExact));
      newMatchActions.push(setInitialJobDetails(jobDetails));
      newMatchActions.push(
        getAllReports({
          jobTitle: jobTitle,
          orgJobId: addJob.orgJobId,
          orgJobTitle: addJob.orgJobTitle,
          orgJobCode: addJob.jobCode,
          noJobCode: addJob.noJobCode,
          workLocation: addJob.workLocationExact,
          jobDetails: jobDetails,
          existingJob: addJob.editJobTitleMode,
          jobDescription: addJob.jobDescription,
          usePayscaleMatch: this.usePayscaleMatch,
          resetDefaultCompFactors: !IsJobPriced(addJob.workLocation, addJob.jobDetails?.PayscaleJobTitle)
        })
      );

      newMatchActions.push(getJobSkills({ params: { title: jobTitle } }));
      newMatchActions.push(getJobCerts({ params: { title: jobTitle } }));
      await Promise.all(newMatchActions)
        .then(() => this.finishLoading(now))
        .catch(err => {
          this.finishLoadingError(err);
        });
    }
  }

  finishLoading(now) {
    const { setJobMatchSaving } = this.props;
    const MINIMUM_TIMEOUT = 4000; // show animation for at least 4 seconds
    const elapsed = Date.now() - now;
    if (elapsed < MINIMUM_TIMEOUT) {
      const remaining = MINIMUM_TIMEOUT - elapsed;
      setTimeout(() => {
        setJobMatchSaving(false);
      }, remaining);
    } else {
      setJobMatchSaving(false);
    }
  }

  finishLoadingError(err) {
    const { setJobMatchError } = this.props;
    setJobMatchError(true);
  }

  jobMatchCardHoverEnter(topMatch) {
    if (!topMatch) this.setState({ cardClassName: 'match-card__top-match--border' });
  }

  jobMatchCardHoverLeave(topMatch) {
    if (!topMatch) this.setState({ cardClassName: '' });
  }

  render() {
    const { addJob, app, className, items, jobRowNum } = this.props;
    const carouselClass = classnames({ className }, 'job-match-carousel');
    const leftChevron = (
      <a className="job-match-carousel__prev-button">
        <i className="icon-left-open" />
      </a>
    );
    const rightChevron = (
      <a className="job-match-carousel__next-button">
        <i className="icon-right-open" />
      </a>
    );

    return (
      <div className={carouselClass}>
        {addJob.searchLoading && !addJob.searchLoaded && (
          <div className="job-match__loading">
            <LoadingIndicator loading={addJob.searchLoading && !addJob.searchLoaded} />
          </div>
        )}
        {!addJob.searchLoading && addJob.searchLoaded && (
          <ItemsCarousel
            activeItemIndex={this.state.activeItemIndex}
            activePosition={'center'}
            firstAndLastGutter={false}
            gutter={31}
            leftChevron={leftChevron}
            numberOfCards={3}
            requestToChangeActive={this.changeActiveItemIndex}
            rightChevron={rightChevron}
            showSlither={false}
            slidesToScroll={1}
          >
            {items.map((job, index) => {
              let payRange = null;
              let currency = null;
              let highVariance = false;
              let percentile10, percentile90;
              let topMatch = index === 0;

              if (
                job.loaded &&
                job.initialPayReports &&
                job.initialPayReports.payReport &&
                job.initialPayReports.payReport.reports &&
                job.initialPayReports.payReport.reports.basePayReport
              ) {
                const percentile25 = job.initialPayReports.payReport.reports.basePayReport.percentile25;
                const percentile50 = job.initialPayReports.payReport.reports.basePayReport.percentile50;
                const percentile75 = job.initialPayReports.payReport.reports.basePayReport.percentile75;
                percentile10 = job.initialPayReports.payReport.reports.basePayReport.percentile10;
                percentile90 = job.initialPayReports.payReport.reports.basePayReport.percentile90;
                currency = job.initialPayReports.payReport.reports.basePayReport.currencyFormat;
                if (currency && currency.length > 0) {
                  currency = currency.substring(0, currency.indexOf('{'));
                  const domParser = new DOMParser();
                  currency = domParser.parseFromString(currency, 'text/html').body.textContent;
                }
                const qualityReportRating = hasQualityReportRating({
                  payscale_job_info: {
                    Reports: job.initialPayReports
                  },
                  workLocationExact: addJob.workLocationExact
                });
                highVariance = qualityReportRating === 2;
                payRange = [percentile25, percentile50, percentile75];
              }

              const currentMatch = addJob?.selectedJobTitle === job.JobTitle;
              const selectedRow = jobRowNum;
              const loading = !job.loaded;
              const tasks =
                job?.Tasks?.length > 0
                  ? job.Tasks.reduce((tasksString, curTask) => {
                      return tasksString + ', ' + curTask;
                    })
                  : '';

              return (
                <JobMatchCard
                  onSelectMatchClick={this.handleSelectJobClick.bind(
                    this,
                    job.ValueID,
                    job.JobTitle,
                    job.Tasks,
                    job.TitleVariations,
                    selectedRow
                  )}
                  jobTitle={job.JobTitle}
                  key={job.ValueID}
                  loadingDetails={loading}
                  payRange={payRange}
                  payRangeScaleMin={percentile10}
                  payRangeScaleMax={percentile90}
                  currentMatch={currentMatch}
                  jobTasks={tasks}
                  matchId={job.ValueID.toString()}
                  jobCurrency={currency}
                  app={app}
                  highVariance={highVariance}
                  topMatch={topMatch}
                  className="job__match-card--hover"
                  onMouseEnter={this.jobMatchCardHoverEnter.bind(this, topMatch)}
                  onMouseLeave={this.jobMatchCardHoverLeave.bind(this, topMatch)}
                  cardClassName={this.state.cardClassName}
                  rangeChartWidth={this.props.rangeChartWidth}
                  feature={this.props.feature}
                  isMP={this.props.isMP}
                />
              );
            })}
          </ItemsCarousel>
        )}
      </div>
    );
  }
}
